import { useState } from 'react';
import useForm from '../../../../customHooks/useForm';
import ProfileTitle from '../ProfileTitle';
import ProfileLabelAndTitle from '../../../../components/ProfileLabelAndTitle';

interface IResidentialDetails{
  payload:any;
  buttonState:boolean;
  disableMode?: boolean
  index?: number
}
const ResidentialDetails = ({
  payload, index,
}:IResidentialDetails) => {
  const {
    formValues,
  } = useForm(
    {
      location: payload?.location || '*******',
      zipCode: payload?.zipCode || '*******',
      city: payload?.city || '*******',
      state: payload?.state || '*******',
      country: payload?.country || '*******',
    },
  );

  const [isResidentialDetailHidden, setIsResidentiallDetailHidden] = useState(false);

  return (
    <div className="employment-details-cover">
      <ProfileTitle
        name="Residential Details"
        index={index}
        onClick={() => setIsResidentiallDetailHidden(!isResidentialDetailHidden)}
      />
      {isResidentialDetailHidden && (
      <div className="profile-detail-cover">
        <ProfileLabelAndTitle
          content={formValues}
          attribute={[
            'location',
            'state',
            'city',
            'zipCode',
          ]}
          label={{
            location: 'Address',
            state: 'State',
            city: 'City',
            zipCode: 'Zip Code',
            phone: 'Phone Number',
          }}
        />
      </div>
      )}
    </div>
  );
};
export default ResidentialDetails;
